import * as components from './components'

export default [
  {
    path: '/program/:cipCode/:programGuideCode/:type/menu',
    component: components.ProgramGuideMenu,
    name: 'programGuideMenu',
    props: true
  },
  {
    path: '/program/:cipCode/:programGuideCode/:type/about',
    component: components.ProgramGuideAbout,
    name: 'programGuideAbout',
    props: true
  },
  {
    path: '/program/:cipCode/:programGuideCode/:type/requirements',
    component: components.ProgramGuideRequirements,
    name: 'programGuideRequirements',
    props: true
  },
  {
    path: '/program/:cipCode/:programGuideCode/:type/concentrations',
    component: components.ProgramGuideConcentrations,
    name: 'programGuideConcentrations',
    props: true
  },
  {
    path: '/program/:cipCode/:programGuideCode/:type/careers',
    component: components.ProgramGuideCareers,
    name: 'programGuideCareers',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/alumniInsights',
    component: components.ProgramGuideAlumniInsights,
    name: 'programGuideAlumniInsights',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/pathways',
    component: components.ProgramGuidePathways,
    name: 'programGuidePathways',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/careerProspects',
    component: components.ProgramGuideCareerProspects,
    name: 'programGuideCareerProspects',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/relatedPrograms',
    component: components.ProgramGuideRelatedPrograms,
    name: 'programGuideRelatedPrograms',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/faq',
    component: components.ProgramGuideFAQ,
    name: 'programGuideFAQ',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/compliance',
    component: components.ProgramGuideCompliance,
    name: 'programGuideCompliance',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/status',
    component: components.ProgramGuideMyProgramStatus,
    name: 'programGuideMyProgramStatus',
    props: true
  },
  {
    path: '/programguide/:cipCode/:programGuideCode/:type/spotlightAlumni',
    component: components.ProgramGuideSpotlightAlumni,
    name: 'programGuideSpotlightAlumni',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/programguide/routes.js